import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { IXenaAppPlugin } from 'src/app/xena-api';

@Component({
    selector: 'app-plugin',
    templateUrl: './plugins.component.html',
    styleUrls: ['./plugins.component.scss'],
    standalone: false
})
export class PluginComponent {
  @Input() appPlugins: IXenaAppPlugin[];
  @Input() pluginsArray: UntypedFormArray;
  @Input() isReadonly = false;
  @Input() cultureSelected = false;

}
